import { render } from "./question-component.vue?vue&type=template&id=00592afe&ts=true"
import script from "./question-component.vue?vue&type=script&lang=ts"
export * from "./question-component.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__